import { render } from "./SuspendMemberModal.vue?vue&type=template&id=a7286528&scoped=true"
import script from "./SuspendMemberModal.vue?vue&type=script&lang=js"
export * from "./SuspendMemberModal.vue?vue&type=script&lang=js"

import "./SuspendMemberModal.vue?vue&type=style&index=0&id=a7286528&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7286528"]])

export default __exports__